// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2uZuq","requiredAsterisk":"Info_requiredAsterisk__2zOFw"};